{
	"cashflow": {
		"title": "CASH FLOW",
		"extract": "Extract",
		"expensses": "Expenses/Revenues",
		"history": "Historic",
		"demonstrative": "Statement"
	},
	"expenses": {
		"title": "EXPENSES",
		"perDescripion": "Per Description",
		"perDay": "Per day",
		"perType": "Per Type",
		"perCategory": "Per Category",
		"perCostCenter": "Per Cost Center",
		"perHistory": "Historic",
		"perAnything": "Paid to..."
	},
	"receipts": {
		"title": "RECEIPTS",
		"perDescripion": "Per Description",
		"perDay": "Per day",
		"perType": "Per Type",
		"perCategory": "Per Category",
		"perCostCenter": "Per Cost Center",
		"perHistory": "Historic",
		"perAnything": "Received from..."
	},
	"competence": "Competence",
	"dueDate": "Due date"
}
